import LicenseManagementHeader from "./LicenseManagementHeader";

export default LicenseManagementHeader;
